import React, { useCallback, useRef } from 'react'
import { Close } from '@/components/svg'
import SegmentHandler from '@/services/analytics/SegmentHandler'
import ButtonBase from '../ButtonBase'
import Modal, { Props as ModalProps } from '../Modal/Modal'
import VideoBox, {
  getVideoSegmentProperties,
  VideoService,
  VideoPlayer,
} from '../VideoBox'

export interface Props extends Omit<ModalProps, 'children'> {
  videoId: string
  campaignSlug: string
  aspectRatio?: number
  service?: VideoService
}

const VideoModal = ({
  setIsOpen,
  videoId,
  campaignSlug,
  aspectRatio,
  service = 'youtube',
  ...rest
}: Props) => {
  const playerRef = useRef<VideoPlayer | null>(null)

  const handleClose = useCallback(async () => {
    const videoProperties = await getVideoSegmentProperties(
      playerRef.current as VideoPlayer,
      campaignSlug,
      service
    )

    SegmentHandler.track('Video Playback Interrupted', {
      ...videoProperties,
      interruption_method: 'modal_dismissed',
    })

    setIsOpen(false)
  }, [setIsOpen, campaignSlug, service])

  return (
    <Modal {...rest} setIsOpen={handleClose} overlayColor="rgba(0,0,0,0.7)">
      <div className="2xl:w-[1400px] relative w-[1068px] max-w-full">
        <div className="flex justify-end xl:pb-2">
          <ButtonBase onClick={handleClose} aria-label="Close Dialog">
            <Close className="h-6 w-6 text-white xl:h-8 xl:w-8" />
          </ButtonBase>
        </div>

        <VideoBox
          id={`modal-video-${videoId}`}
          campaignSlug={campaignSlug}
          video={videoId}
          lazyload={false}
          className="w-full"
          ref={playerRef}
          aspectRatio={aspectRatio}
          service={service}
        />
      </div>
    </Modal>
  )
}

export default VideoModal
